import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";

const FeatureUnavailable = ({ heading = "Feature Unavailable" }) => {
  return (
    <Box
      sx={{
        height: "80vh",            // takes most of page height
        display: "flex",
        justifyContent: "center", // horizontally center
        alignItems: "center",     // vertically center
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: "center",
          borderRadius: 3,
          maxWidth: 400,
        }}
      >
        <Box display="flex" justifyContent="center" mb={2}>
          <BlockIcon sx={{ fontSize: 50, color: "error.main" }} />
        </Box>

        <Typography variant="h5" fontWeight={600} gutterBottom>
          {heading}
        </Typography>

        <Typography variant="body1" color="text.secondary">
          This feature is not enabled for your account. <br />
          Please contact the administrator.
        </Typography>
      </Paper>
    </Box>
  );
};

export default FeatureUnavailable;
